/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */
import React, { Fragment } from 'react'

export const showAdditionalDetailsForm = [
  {
    label: (
      <Fragment>
        <p>NO,</p>
        <p>I accept the defaults.</p>
      </Fragment>
    ),
    value: 'True'
  },
  {
    label: (
      <Fragment>
        <p>YES</p>
        <p>I’ll review and customize</p>
      </Fragment>
    ),
    value: 'False'
  },
]

export const planServiceRequirement = [
  {
    label: '0 (default) years',
    value: 'A'
  },
  {
    label: '1 year',
    value: 'B'
  },
  {
    label: '2 years',
    value: 'C'
  },
  {
    label: '3 years',
    value: 'D'
  }
]

export const planAgeRequirement = [
  {
    label: 'No requirement (default)',
    value: 'NA'
  },
  {
    label: '14',
    value: '14'
  },
  {
    label: '15',
    value: '15'
  },
  {
    label: '16',
    value: '16'
  },
  {
    label: '17',
    value: '17'
  },
  {
    label: '18',
    value: '18'
  },
  {
    label: '19',
    value: '19'
  },
  {
    label: '20',
    value: '20'
  },
  {
    label: '21',
    value: '21'
  },
]

export const employeesEligible = [
  { label: 'Collective bargaining unit Employees as described in Section 3.02(A) of the Plan.',
    value: 'A',
    name: 'sepEligibleClassParticipantsA'
  },
  { label: 'Non-resident aliens as described in Section 3.02(B) of the Plan.',
    value: 'B',
    name: 'sepEligibleClassParticipantsB'
  },
  { label: 'Acquired Employees as described in Section 3.02(C) of the Plan.',
    value: 'C',
    name: 'sepEligibleClassParticipantsC'
  },
  { label: `Employees who have received less than $450 (indexed for cost-of-living
    increases in accordance with Code section 408(k)(8)) of Compensation from
    the Employer during the Plan Year as described in Section 3.02(D) of the Plan.`,
  value: 'D',
  name: 'sepEligibleClassParticipantsD'
  }
]

export const contributionFormula = [
  {
    label: 'Discretionary Formula. For each Plan Year, the Employer will contribute an amount to be determined from year to year. (Default)',
    value: 'A',
  },
  {
    label: 'Fixed Percent of Profits Formula',
    value: 'B',
  },
  {
    label: 'Not Applicable. The Employer will not make Employer Contributions to this Plan.',
    value: 'C',
  }
]

export const allocationFormula = [
  {
    label: 'Pro Rata Formula. The Employer Contribution for each Plan Year shall be allocated in the manner described in Section 4.01(B)(1) of the Plan. (default)',
    value: 'A'
  },
  {
    label: 'Flat Dollar Formula. The Employer Contributions allocated to the IRAs of Participants shall be the same dollar amount for each Participant.',
    value: 'B'
  },
  {
    label: 'Integrated Formula. The Employer Contribution shall be allocated in the manner described in Section 4.01(B)(2) of the Plan.',
    value: 'C'
  }
]

export const topHeavyMinimumAllocation = [
  {
    label: 'To this plan (Default)',
    value: 'A'
  },
  {
    label: 'To the following plan maintained by the Employer. Specify the name and plan sequence number of the plan.',
    value: 'B'
  }
]

export const conpensationElections = [
  {
    label: 'W-2 wages (Default)',
    value: 'A'
  },
  {
    label: 'Section 3401(a) wages',
    value: 'B'
  },
  {
    label: '415 safe-harbor compensation',
    value: 'C'
  }
]

export const planYear = [
  {
    label: 'The 12-consecutive-month period which coincides with the Adopting Employer’s fiscal year (default)',
    value: 'A'
  },
  {
    label: 'The calendar year',
    value: 'B'
  },
  {
    label: 'Other 12-consecutive-month period. Specify a 12-consecutive-month period selected in a uniform and nondiscriminatory manner. If the initial Plan Year is a short Plan Year (i.e., less than 12 months), specify such Plan Year’s beginning and ending dates.',
    value: 'C'
  }
]

export const sepYesOrNo = {
  yesDefault: [
    { label: 'Yes (Default)', value: 'Yes' }, { label: 'No', value: 'No' }
  ],
  noDefault: [
    { label: <span>Yes</span>, value: 'Yes' }, { label: 'No (Default)', value: 'No' }
  ]
}

export const SERVICE_REQUIREMENT_VALUES = {
  NO_ELIGIBILITY: 'Option 1: No eligibility service required',
  CONSECUTIVE_MONTHS: `Option 2: After completing ___ consecutive Months of Eligibility Service (not more than 12) beginning on the Employee's date of hire.`,
  ELIGIBILITY_YEARS: `Option 3: after completing ___ years of eligibility service (enter 0 or 1)`,
}

export const serviceRequirement401k = [
  {
    label: 'No eligibility service required. (default)',
    value: SERVICE_REQUIREMENT_VALUES.NO_ELIGIBILITY,
  },
  {
    label: `After completing consecutive Months of Eligibility Service (not more than 12) beginning on the Employee's date of hire.`,
    value: SERVICE_REQUIREMENT_VALUES.CONSECUTIVE_MONTHS,
  },
  {
    label: `After completing years of eligibility service (enter 0 or 1)`,
    value: SERVICE_REQUIREMENT_VALUES.ELIGIBILITY_YEARS,
  },
]

export const simpleIraServiceRequirement = [
  {
    label: 'Full Eligibility. All Employees are eligible. (default)',
    value: 'A'
  },
  {
    label: 'Limited Eligibility. ',
    value: 'B'
  },
]

export const simpleIraEmployeesEligible = [
  { label: 'Collective bargaining unit Employees as described in Section 3.02(A) of the Plan.',
    value: 'A',
    name: 'simpleEligibleClassParticipantsA'
  },
  { label: 'Non-resident aliens as described in Section 3.02(B) of the Plan.',
    value: 'B',
    name: 'simpleEligibleClassParticipantsB'
  },
  { label: 'Acquired Employees as described in Section 3.02(C) of the Plan.',
    value: 'C',
    name: 'simpleEligibleClassParticipantsC'
  },
]

export const simpleIraElectionPeriods = [
  {
    label: 'Annually',
    value: 'A'
  },
  {
    label: 'Semi-annually',
    value: 'B'
  },
  {
    label: 'Quaterly',
    value: 'C'
  },
  {
    label: 'Monthly',
    value: 'D'
  },
  {
    label: 'Bi-weekly',
    value: 'E'
  },
  {
    label: 'Weekly',
    value: 'F'
  },
  {
    label: 'Daily',
    value: 'G'
  },
  {
    label: 'Not Specified (Default)',
    value: 'H'
  },
]

export const simpleCompYears = [
  {
    label: '0 (Default)',
    value: '0'
  },
  {
    label: '1',
    value: '1'
  },
]



// WEBPACK FOOTER //
// ./src/utils/financialAccountAdditionalDetailsOptions.js